import { lazy } from 'react';

export const lazyImportNamed = (factory: () => Promise<any>, namedExportName = 'default') => {
  return lazy(() =>
    factory().then((moduleExports) => {
      return { ['default']: moduleExports[namedExportName] };
    })
  );
};
